var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-shrink-0 rounded-xl px-4 py-2 text-white-text font-bold shadow",class:_vm.classList},[_vm._v(" "+_vm._s(_vm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }